/**
 * Created by qinghua.gong on 2019/10/14.
 */
import ElementUI from './element-index.js'
import Vue from 'vue'



let install = Vue => {
  Vue.use(ElementUI)
  Vue.component('navMenu',() => import('@common/comp/index/navMenu.vue'))
  Vue.component('navHeader',() => import('@common/comp/index/header.vue'))
}

export let use = Vue =>{
  install(Vue)
}



// WEBPACK FOOTER //
// ./src/common/index.js